var EPK = EPK || {};
EPK.Product = EPK.Product || {};
EPK.ProductCart = EPK.ProductCart || {};
EPK.ProductShopItemDetail = EPK.ProductShopItemDetail || {};

EPK.ProductCart.DefaultErrorMessage = 'エラーが発生しました。<br>画面を再読込してもう一度実行して<br>ください。';

$(function(){
	$('#set_cart_item').on('click', function(event){
		EPK.ProductCart.setCartItem();
	});

	$('#item_num_now').on('change', function(event){
		EPK.ProductCart.changeItemNum(event);
	});

	$('.shop-detail-modal-reload').on('click', function(event){
		EPK.ProductCart.reload();
	});

	EPK.ProductShopItemDetail.Map();

	$('#modal-shop-info-btn').on('click', function(event) {
		EPK.ProductShopItemDetail.openModal('#modal-shop-info');
	});

	$('#modal-login-btn').on('click', function() {
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal-login'},
			type: 'inline',
			modal: true
		}, 0);
	});

	var $slider = $('#slider-items');
	if($slider.find(".swiper-slide").length > 1){
		var swiper = $slider.swiper({
			loop:true,
			centeredSlides: true,
			slidesPerView: 1,
			nextButton: '.slider-fwd',
			prevButton: '.slider-rev',
			pagination: '.swiper-pagination',
			preloadImages: true,
		});
	}else{
		$('.slider-fwd').hide();
		$('.slider-rev').hide();
	}

	if(EPK.common.isMobile){
		$('.modal-product-item-stock-num-btn').on('click', function(event) {
			event.preventDefault();
			$.magnificPopup.close();
			$.magnificPopup.open({
				items: {src: $('#modal-product-item-stock-num')},
				type: 'inline',
				modal: true,
			}, 0);
		});

		$('.modal-product-item-stock-btn-sp').on('click', function(event) {
			event.preventDefault();

			$('#modal-product-item-stock-num-tel').text($(this).data('tel'));
			$('#modal-product-item-stock-num-opentime').text($(this).data('opentime'));
			$('#modal-product-item-stock-num-shopname').text($(this).data('shopname'));
			$('#modal-product-item-stock-num-holiday').text($(this).data('holiday'));
			$('#modal-product-item-stock-num-tel-href').prop('href', 'tel:' + $(this).data('tel'));

			$.magnificPopup.close();
			$.magnificPopup.open({
				items: {src: $('#modal-product-item-stock')},
				type: 'inline',
				modal: true,
			}, 0);
		});

	}

	EPK.ProductShopItemDetail.getLocation();

	/*
	 * 以下PCのみ
	 */
	// サムネイルの変更処理
	$(".js-thumbnail-list").on('click', function(e) {
		var $mainImage = $("#" + $(this).attr("data-mainImage"));
		$mainImage.attr('src', $(this).attr("src"));
	});

	// 「店舗在庫数について」モーダル
	$('.zaiko-quantity').on('click', function (event) {
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal_stock_num'},
			type: 'inline',
			modal: false,
			showCloseBtn: false
		}, 0);
	});

	// 「店舗在庫状況について」モーダル
	$('.modal-product-item-stock-btn').on('click', function (event) {
		// モーダルテキスト書き換え
		$('#modal_stock_situation .shopname').text(event.currentTarget.dataset.shopname);
		$('#modal_stock_situation .tel').text(event.currentTarget.dataset.tel);
		$('#modal_stock_situation .time').text('営業時間 ' +event.currentTarget.dataset.opentime);
		if (event.currentTarget.dataset.holiday != 'なし') {
			$('#modal_stock_situation .time').append('（'+ event.currentTarget.dataset.holiday +'定休）');
		}
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal_stock_situation'},
			type: 'inline',
			modal: false,
			showCloseBtn: false
		}, 0);
	});

	// レコメンド
	var $recommend_slider = $('.recommend-slide');
	if($recommend_slider.find(".swiper-slide").length > 1){
		$recommend_slider.swiper({
			loop:true,
			spaceBetween: 20,
			slidesPerView: 6,
			initialSlide: 0,
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			preloadImages: true,
		});
	}

	// SP版：#14792
	if($('#other-itemslide-async').length) {
		// この店舗のその他取扱い商品取得
		EPK.ProductShopItemDetail.setOtherItemlist();
	}
});

EPK.ProductCart.changeItemNum = function(event){
	var shopItemCountBox = $('.shop-item-count');

	var handlingType = shopItemCountBox.data('handling_type');
	var stockNumManageFlag = shopItemCountBox.data('stock_num_manage_flag');
	var stockNum = shopItemCountBox.data('stock_num');
	var saleNumLeast = shopItemCountBox.data('sale_num_least');
	var saleNumLimit = shopItemCountBox.data('sale_num_limit');

	var afterCartItemNum = $(event.target).val();

	var isCommonCheckStockNum = EPK.ProductCart.getIsCommonCheckStockNum(handlingType, stockNumManageFlag);

	if(isCommonCheckStockNum){
		if(stockNum <= 0){
			EPK.ProductCart.setItemNumErrorStatus('ただいま在庫がありません');
			return false;
		}

		if(stockNum < afterCartItemNum){
			EPK.ProductCart.setItemNumErrorStatus('本商品は' + stockNum + '点までの購入となります。');
			return false;
		}
	}

	switch(handlingType){
		case 0:
			if(stockNum < saleNumLeast){
				EPK.ProductCart.setItemNumErrorStatus('ただいま在庫がありません');
				return false;
			}
			break;

		default:
			break;
	}

	if(saleNumLimit > 0){
		if(saleNumLimit < afterCartItemNum){
			EPK.ProductCart.setItemNumErrorStatus('本商品はおひとりさま' + saleNumLimit + '点までの購入となります。');
			return false;
		}
	}

	return true;
};

EPK.ProductCart.getIsCommonCheckStockNum = function(handlingType, stockNumManageFlag){
	switch(handlingType){
		case 0:
			return true;

		case 1:
			if(stockNumManageFlag){
				return true;
			}
			break;

		default:
			break;
	}

	return false;
};

EPK.ProductCart.setStockNumZeroStatus = function(){
	$('.shop-item-count').remove();
	$('.settlement-btn').after('<div class="soldout">ただ今在庫がありません</div>');
	$('.settlement-btn').remove();
};

EPK.ProductCart.setCartItem = function(){
	$('#set_cart_item').hide();

	$.magnificPopup.close();

	var itemNumNow = $('#item_num_now').val();

    var shopItemCountBox = $('.shop-item-count');

	var shopId = shopItemCountBox.data('shop_id');
	var toriokiShopItemId = shopItemCountBox.data('torioki_shop_item_id');
	var handlingType = shopItemCountBox.data('handling_type');
	var stockNumManageFlag = shopItemCountBox.data('stock_num_manage_flag');
	var stockNum = shopItemCountBox.data('stock_num');
	var saleNumLeast = shopItemCountBox.data('sale_num_least');
	var saleNumLimit = shopItemCountBox.data('sale_num_limit');
	var cartItemNumNow = shopItemCountBox.data('cart_item_num_now');

	if($.isEmptyObject(itemNumNow) || !$.isNumeric(itemNumNow) || itemNumNow <= 0){
		EPK.ProductCart.setItemNumErrorStatus('数量を入力してください。');
		console.log('num is not available. ' + itemNumNow);
		return false;
	}

	if(!$.isNumeric(shopId)){
		EPK.ProductCart.setItemNumErrorStatus(EPK.ProductCart.DefaultErrorMessage);
		console.log('shop_id is not numeric. ' + shopId);
		return false;
	}

	if(!$.isNumeric(toriokiShopItemId)){
		EPK.ProductCart.setItemNumErrorStatus(EPK.ProductCart.DefaultErrorMessage);
		console.log('torioki_shop_item_id is not numeric. ' + toriokiShopItemId);
		return false;
	}

	if((!$.isNumeric(handlingType)) || (handlingType != 0 && handlingType != 1)){
		EPK.ProductCart.setItemNumErrorStatus(EPK.ProductCart.DefaultErrorMessage);
		console.log('handling_type is not available. ' + handlingType);
		return false;
	}

	var afterCartItemNum = itemNumNow;
	if(cartItemNumNow > 0){
		afterCartItemNum = Number(afterCartItemNum) + Number(cartItemNumNow);
	}

	var isCommonCheckStockNum = EPK.ProductCart.getIsCommonCheckStockNum(handlingType, stockNumManageFlag);

	if(isCommonCheckStockNum){
		if(stockNum <= 0){
			EPK.ProductCart.setItemNumErrorStatus('ただいま在庫がありません');
			return false;
		}

		// #10776
		//if(stockNum < afterCartItemNum){
		if((Number(stockNum) - Number(itemNumNow)) < 0){
			EPK.ProductCart.setItemNumErrorStatus('本商品は' + stockNum + '点までの購入となります。');
			return false;
		}
	}

	switch(handlingType){
		case 0:
			if(stockNum < saleNumLeast){
				EPK.ProductCart.setItemNumErrorStatus('ただいま在庫がありません');
				return false;
			}
			break;

		default:
			break;
	}

	if(saleNumLeast > 1){
		if(afterCartItemNum < saleNumLeast){
			EPK.ProductCart.setItemNumErrorStatus('本商品は' + saleNumLeast + '点からの購入となります。');
			return false;
		}
	}

	if(saleNumLimit > 0){
		if(saleNumLimit < afterCartItemNum){
			EPK.ProductCart.setItemNumErrorStatus('本商品はおひとりさま' + saleNumLimit + '点までの購入となります。');
			return false;
		}
	}

	$.ajax({
		type: 'POST',
		url: '/product/set_cart',
		data: {
				'shop_id': shopId,
				'torioki_shop_item_id': toriokiShopItemId,
				'num': itemNumNow,
			},
		cache: false,
		dataType : 'json',
		timeout: 80000
	}).done(function(data){
		if(data['result'] == 'success'){
			$('#set_cart_item').show();
			$.magnificPopup.open({
				items: {src: '#modal-item-add'},
				type: 'inline',
				modal: true
			}, 0);
		}else
		if(data['result'] == 'no_login'){
			$('#set_cart_item').show();
			$.magnificPopup.open({
				items: {src: '#modal-login'},
				type: 'inline',
				modal: true
			}, 0);
			return false;
		}else
		if(data['result'] == 'error'){
			var errorMessage = EPK.ProductCart.makeErrorMessage(data['error_message_list']);
			EPK.ProductCart.setItemNumErrorStatus(errorMessage);
			console.log('error');
			return false;
		}else
		if(data['result'] == 'not_post'){
			EPK.ProductCart.setItemNumErrorStatus(EPK.ProductCart.DefaultErrorMessage);
			console.log('not post');
			return false;
		}else{
			EPK.ProductCart.setItemNumErrorStatus(EPK.ProductCart.DefaultErrorMessage);
			console.log('exception');
			return false;
		}
	}).fail(function(data){
		EPK.ProductCart.setItemNumErrorStatus(EPK.ProductCart.DefaultErrorMessage);
		console.log('failed');
		console.log(data);
		return false;
	});
};

EPK.ProductCart.setItemNumErrorStatus = function(errorMessage){
	$('#set_cart_item').show();

	EPK.ProductCart.dispErrorMessage(errorMessage);
};

EPK.ProductCart.dispErrorMessage = function(message){
	$('#error-message-num').html(message);

	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-error-message-num'},
		type: 'inline',
		modal: true
	}, 0);
};

EPK.ProductCart.makeErrorMessage = function(errorMessageList){
	var errorMessageText = '';
	$.each(errorMessageList, function(key, val) {
		if(errorMessageText != ''){
			errorMessageText = errorMessageText + '<br>';
		}
		errorMessageText = errorMessageText + val;
	});

	return errorMessageText;
};

EPK.ProductCart.reload = function(){
	location.reload();
};

EPK.ProductShopItemDetail.Map = function(){
	var canvas = document.getElementById('map-canvas');
	if (canvas) {
		var icon = canvas.getAttribute('target-icon');
		var lat = canvas.getAttribute('target-lat');
		var lng = canvas.getAttribute('target-lng');
		var latlng = new google.maps.LatLng(lat, lng);

		var mapOptions = {
			zoom: 18,
			center: latlng,
			gestureHandling: 'greedy',
			mapId:"DEMO_MAP_ID"
		};
		var map = new google.maps.Map(canvas, mapOptions);

		var markers = [];

		markers[0] = new google.maps.marker.AdvancedMarkerElement({
			map: map,
			position: latlng,
			// icon: icon,
		});
		markers[0].content.className = "animation-down"
	}
};

EPK.ProductShopItemDetail.openModal = function(template) {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: template},
		type: 'inline',
		modal: true
	}, 0);
}

/**
 * 現在地（緯度経度）取得処理
 * ※※位置情報取得できない場合のハンドリングが必要なので
 * ※※共通処理(EPK.common.currentPlaceCallback)は利用しない
 *
 */
EPK.ProductShopItemDetail.getLocation = function() {

	function successFunc(position) {
		var $data = position.coords ;
		var $lat = $data.latitude;
		var $lng = $data.longitude;

		doAttributeParams($lat, $lng);
	}

	function errorFunc() {
		doAttributeParams(1, 1);
	}

	function doAttributeParams(lat, lng) {
		var href_backto = $('.SP_itemdetail-head .backto a').prop('href');
		$('.SP_itemdetail-head .backto a').prop('href', href_backto + '?lat=' + lat + '&lng=' + lng + '&sort=close');

		var href_maker = $('.SP_itemdetail-head .maker a').prop('href');
		$('.SP_itemdetail-head .maker a').prop('href', href_maker + '?lat=' + lat + '&lng=' + lng + '&sort=close');
	}

	var tmpLat = Cookies.get('lat');
	var tmpLng = Cookies.get('lng');
	if(tmpLat && tmpLng) {
		successFunc({coords: {latitude: tmpLat*1.0, longitude: tmpLng*1.0}});
		return;
	}

	var optionObj = {
		"enableHighAccuracy": true,
		"timeout": 8000,
		"maximumAge": 2000,
	};

	// Geolocation APIの対応判定
	if(navigator.geolocation) {
		// 現在位置を取得
		navigator.geolocation.getCurrentPosition(successFunc, errorFunc, optionObj);
	}else {
		errorFunc();
	}
};

/**
 * この店舗のその他取扱い商品取得
 */
EPK.ProductShopItemDetail.setOtherItemlist = function() {
	var objSection = $('#other-itemslide-async');

	var data = {
		'shop_id': EPK.common.params['shop_id'],
		'item_id': EPK.common.params['item_id'],
	}

	$.ajax({
		url: '/product/set_other_itemlist',
		type: 'GET',
		data: data,
		cache: false,
		dataType: "html",
	}).done(function(data, textStatus, jqXHR) {
		if (data){
			objSection.empty();
			objSection.append(data);
			objSection[0].style.display = '';
		} else {
			objSection[0].style.display = 'none';
			console.log('not item');
		}
	}).fail( function(data, textStatus, jqXHR) {
		console.log('failed');
	});
};